<template>
  <div>
    <h2 class="title is-size-4-mobile">{{ $t('general.region') }}</h2>
    <TemplateTextBlock v-for="block in text" :key="block.headline" :block="block" />
  </div>
</template>

<script>
import TemplateTextBlock from './TemplateTextBlock'

export default {
  name: 'RegionInfo',
  components: {
    TemplateTextBlock,
  },
  props: {
    text: Array,
  },
}
</script>

<style scoped lang="scss"></style>
